import { render, staticRenderFns } from "./PopupSearch.vue?vue&type=template&id=21dbcf55&"
import script from "./PopupSearch.vue?vue&type=script&lang=js&"
export * from "./PopupSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports